import { Layout } from 'antd';
import classNames from 'classnames';
import type React from 'react';

import { Header } from 'src/components/layout/main-layout/header/header';
import { Sidebar } from 'src/components/layout/main-layout/sidebar/sidebar';

interface MainLayoutProps {
  children: React.ReactNode;
  isCalculatorRoute: boolean;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children, isCalculatorRoute }) => {
  return (
    <Layout
      className={classNames('min-h-screen', {
        'min-w-[360px]': isCalculatorRoute,
        'min-w-[1280px]': !isCalculatorRoute,
      })}
    >
      <Header isCalculatorRoute={isCalculatorRoute} />

      <Layout>
        {!isCalculatorRoute && <Sidebar />}

        <Layout.Content
          className={classNames('pb-18', {
            'px-20 md:px-32 max-sm:pt-56': isCalculatorRoute,
            'px-24': !isCalculatorRoute,
          })}
        >
          {children}
        </Layout.Content>
      </Layout>
    </Layout>
  );
};
